import { makeStyles } from '@material-ui/core';

import { LYNKED_WHITE } from 'src/consts/colors';

export default makeStyles(() => ({
  loginRoot: {
    backgroundColor: LYNKED_WHITE,
  },
}));
